import { IconWrapper } from '../runtime';
export default IconWrapper('banana', true, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48",
      "fill": "none"
    }
  }, [h("g", {
    "attrs": {
      "clip-path": 'url(#' + props.id + 'da321835' + ')'
    }
  }, [h("path", {
    "attrs": {
      "d": "M16 32C13.2005 31.0668 9.96557 28.8274 8.52449 26.5745C8.3271 26.2659 8.25594 25.8975 8.27984 25.5319L8.52501 21.7819C8.57794 20.9722 9.53478 20.5412 10.196 21.0115C12.3296 22.5293 16.2286 25 19 25C26 25 32 22.5 35 17",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M25.9999 43C35.9998 40.9999 45.2427 30.5149 42.8675 19.9413L41.9998 16L41.9998 7.99998L35.9998 6.99997C35.9998 19.9413 33 30 19.9999 32C14.0236 32.9194 8.29461 31.6136 3.87067 29.0781L4.99988 36C6.99982 41 16 45 25.9999 43Z",
      "fill": props.colors[1],
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  })]), h("defs", [h("clipPath", {
    "attrs": {
      "id": props.id + 'da321835'
    }
  }, [h("rect", {
    "attrs": {
      "width": "48",
      "height": "48",
      "fill": props.colors[2]
    }
  })])])]);
});